import React, { useState, useEffect, PureComponent } from "react";
import "./css/SCPChart.css";

import {
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  Legend,
  BarChart,
  Bar,
  Brush,
} from "recharts";

import { Styles, color } from "./SCPChartHelpers";

import { BarCustomTooltip } from "./CustomToolTip";

const SCPBarChart = ({ jsonData, title, chartType }) => {
  const [inputData, setInputData] = useState([]);

  const getBarChart = () => {
    const keysArr = Object.keys(jsonData[0]).slice(1);
    const barArr = [];
    keysArr.forEach((item, index) => {
      barArr.push(<Bar dataKey={item} fill={color[index]} radius={4} />);
    });
    return barArr;
  };
  const getStackedBarChart = () => {
    const keysArr = Object.keys(jsonData[0]).slice(1);
    const barArr = [];
    keysArr.forEach((item, index) => {
      barArr.push(
        <Bar stackId="a" dataKey={item} fill={color[index]} radius={4} />
      );
    });
    return barArr;
  };

  useEffect(() => {
    const jsonString = document.getElementById("inputData").textContent;
    if (jsonString) {
      const values = new Set();
      jsonData.forEach((item) => {
        values.add(item);
      });
      setInputData(Array.from(values));
      setInputData(jsonData);
    }
  }, []);

  if (chartType.includes("barStackedChart")) {
    return (
      <div>
        <div className="chartTitle">{title}</div>
        <BarChart
          width={1500}
          height={400}
          data={jsonData}
          accessibilityLayer
          margin={{
            top: 20,
            right: 30,
            left: 20,
            bottom: 5,
          }}
        >
          <CartesianGrid
            strokeDasharray="3 3"
            horizontal={false}
            vertical={false}
          />
          <XAxis
            className="AxisLabels"
            dataKey={Object.keys(jsonData[0])[0]}
            angle={-30}
            height={80}
            minTickGap={30}
            textAnchor="end"
            tickLine={false}
            tickMargin={10}
            axisLine={false}
          />
          <YAxis className="AxisLabels" />
          <Tooltip
            coordinate={{ y: 100 }}
            content={
              <BarCustomTooltip active={false} payload={[]} label={""} />
            }
          />
          <Legend className="Legend" />
          {getStackedBarChart()}
          <Brush dataKey={Object.keys(jsonData[0])[0]}>
            <BarChart>{getStackedBarChart()}</BarChart>
          </Brush>
        </BarChart>
      </div>
    );
  } else if (chartType.includes("barChart")) {
    return (
      <div>
        <div className="chartTitle">{title}</div>
        <BarChart
          width={1500}
          height={400}
          data={jsonData}
          accessibilityLayer
          margin={{
            top: 20,
            right: 30,
            left: 20,
            bottom: 5,
          }}
        >
          <CartesianGrid
            strokeDasharray="3 3"
            horizontal={false}
            vertical={false}
          />
          <XAxis
            className="AxisLabels"
            dataKey={Object.keys(jsonData[0])[0]}
            angle={-30}
            height={80}
            minTickGap={30}
            textAnchor="end"
            tickLine={false}
            tickMargin={10}
            axisLine={false}
          />
          <YAxis className="AxisLabels" />
          <Tooltip
            coordinate={{ y: 100 }}
            content={
              <BarCustomTooltip active={false} payload={[]} label={""} />
            }
          />
          <Legend className="Legend" />
          {getBarChart()}
          <Brush dataKey={Object.keys(jsonData[0])[0]}>
            <BarChart>{getBarChart()}</BarChart>
          </Brush>
        </BarChart>
      </div>
    );
  }
};

export default SCPBarChart;
